import { Step } from 'react-joyride';

export const sellerDealTrackerSteps: Step[] = [
  {
    target: 'body',
    content: 'Welcome to the Deal Tracker! Track your deals from purchase agreement all the way to closing.',
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: '[data-tour="deal-tracker-header"]',
    content: 'Click "New Deal" to add a deal you\'re working on. Track seller info, property details, and expected commission.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="deal-tracker-stages"]',
    content: 'See how many deals are in each stage at a glance. Click any stage card to filter your view.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="deal-tracker-filters"]',
    content: 'Search by seller name, property address, or email. Use the dropdown to filter by specific stages.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="deal-tracker-table"]',
    content: 'Your deals appear here. Click any row to view details, update the stage, or add notes.',
    placement: 'top',
    disableBeacon: true,
  },
];
